export enum LogoType {
  Name,
  Claim,
  ClaimSmall,
  BcIcon,
  BcIconInvert
}
